import camelCase from 'lodash/camelCase'
import startCase from 'lodash/startCase'
import React from 'react'

import { USStates } from '../../models/USStates.model'

type CalculatorStateFieldProps = {
  state: USStates
  onStateChange: (state: USStates) => void
}

export const CalculatorStateField: React.FC<CalculatorStateFieldProps> = ({ state, onStateChange }) => {
  return (
    <div>
      <label className="mb-1.5 block text-xs font-semibold text-graphite-grey sm:text-sm">State</label>
      <select
        name="state"
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-royal-indigo sm:px-4"
        value={state}
        onChange={(evt) => onStateChange(evt.target.value as USStates)}
      >
        {Object.entries(USStates).map((stateOption) => (
          <option key={stateOption[1]} value={stateOption[1]}>
            {startCase(camelCase(stateOption[0]))}
          </option>
        ))}
      </select>
    </div>
  )
}
